import type { ProjectCommentTargetKind } from '@paladin-monorepo/common';

const PREFIX = 'paladin.commentSeen.v1';

function storageKey(projectId: string, targetKind: ProjectCommentTargetKind, targetId: string): string {
  return `${PREFIX}:${projectId}:${targetKind}:${targetId}`;
}

export function getProjectCommentSeenAt(
  projectId: string,
  targetKind: ProjectCommentTargetKind,
  targetId: string,
): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return window.localStorage.getItem(storageKey(projectId, targetKind, targetId));
  } catch {
    return null;
  }
}

export function setProjectCommentSeenAt(
  projectId: string,
  targetKind: ProjectCommentTargetKind,
  targetId: string,
  seenAtIso: string,
): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(storageKey(projectId, targetKind, targetId), seenAtIso);
    window.dispatchEvent(new Event('paladin-project-comment-seen'));
  } catch {
    /* ignore quota / private mode */
  }
}

export const PROJECT_COMMENT_SEEN_EVENT = 'paladin-project-comment-seen';
